import React, { useState, useEffect } from 'react';
import { FiPackage, FiClock, FiCheck, FiTruck, FiX } from 'react-icons/fi';
import Loader from '../components/Loader';
import API from '../services/api';

const statusConfig = {
  en_attente: { label: 'En attente', icon: <FiClock size={16} />, color: 'bg-yellow-100 text-yellow-700' },
  confirmee: { label: 'Confirmée', icon: <FiCheck size={16} />, color: 'bg-blue-100 text-blue-700' },
  expediee: { label: 'Expédiée', icon: <FiTruck size={16} />, color: 'bg-purple-100 text-purple-700' },
  livree: { label: 'Livrée', icon: <FiCheck size={16} />, color: 'bg-green-100 text-green-700' },
  annulee: { label: 'Annulée', icon: <FiX size={16} />, color: 'bg-red-100 text-red-700' },
};

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await API.get('/orders/my-orders');
        setOrders(res.data);
      } catch (error) {
        console.error('Erreur chargement commandes:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">
        Mes <span className="text-primary">Commandes</span>
      </h1>

      {orders.length === 0 ? (
        <div className="text-center py-20">
          <FiPackage size={64} className="text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">Vous n'avez pas encore de commandes.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {orders.map((order) => {
            const status = statusConfig[order.orderStatus];
            return (
              <div key={order._id} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                
                {/* Header commande */}
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="text-sm text-gray-500">Commande</p>
                    <p className="font-mono text-sm font-semibold text-gray-700">
                      #{order._id.slice(-8).toUpperCase()}
                    </p>
                  </div>
                  <span className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-semibold ${status.color}`}>
                    {status.icon}
                    {status.label}
                  </span>
                </div>

                {/* Produits */}
                <div className="space-y-2 mb-4">
                  {order.products.map((item, index) => (
                    <div key={index} className="flex justify-between text-sm">
                      <span className="text-gray-600">
                        {item.product?.name || 'Produit'} x{item.quantity} ({item.size})
                      </span>
                      <span className="font-semibold">
                        {(item.price * item.quantity).toLocaleString()} FCFA
                      </span>
                    </div>
                  ))}
                </div>

                {/* Footer */}
                <div className="border-t border-gray-100 pt-4 flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500">Adresse de livraison</p>
                    <p className="text-sm font-medium text-gray-700">{order.shippingAddress}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">Total</p>
                    <p className="font-bold text-primary text-lg">
                      {order.totalAmount.toLocaleString()} FCFA
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Orders;